import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CaseDetails, Tag } from 'app/shared/models/case.models';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as api from '../../shared/api/apihandler';

export class CaseFunctions {
    constructor(private http: HttpClient){ }
    bearer = localStorage.getItem('bearer') as string;
    getCase(id):Observable<CaseDetails>{
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<CaseDetails>(api.jubloApi + 'api/Website/Case/CaseDetails/' + id, { headers })
    }

    getCaseStages(){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetCaseStages', { headers })
    }
    
    setCaseStage(caseId:string, stageId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        if(!!stageId){
            this.http.patch(api.jubloApi + 'api/Website/Case/SetCaseStage/'+ caseId + '?StageId=' + stageId,{},{headers}).subscribe(
                (data)=>{}
            )
        }
        else {
            this.http.patch(api.jubloApi + 'api/Website/Case/SetCaseStage/'+ caseId + '?StageId=' + null,{},{headers}).subscribe(
                (data)=>{}
            )
        }
    }

    removeContactFromCase(caseId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        this.http.patch(api.jubloApi + '/api/Website/Case/RemoveContact/' + caseId, {}, { headers } ).subscribe(
            ()=>{}
        )
    }

    getPartnerCaseInfo(partnerCaseId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetPartnerCaseInfo/' + partnerCaseId, { headers })
    }

    getOSCaseStatus(partnerCaseId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/Case/GetOSCaseStatus/' + partnerCaseId, { headers })
    }

    getCaseFromPartner(caseId:string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Partner/ReceivedPartnerCaseInfo/' + caseId, { headers })
    }

    getCaseDistributedPartners(caseId:string): Observable<any> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Partner/PartnerCaseInfo/' + caseId, { headers })
    }

    getCasePartners(caseId: string): Observable<{ from: any, to: any[] }> {
        const from$ = this.getCaseFromPartner(caseId);
        const to$ = this.getCaseDistributedPartners(caseId);
    
        return forkJoin([from$, to$]).pipe(
          map(([from, to]) => {
            return { from, to };
          })
        );
      }

    getWaitingPartners(caseId:string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/CaseTransfer/CheckIfExist/' + caseId, { headers })
    }

    cancelCaseTransfer(transferId:string){
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.delete(api.jubloApi + 'api/Website/CaseTransfer/CancelCaseTransfer/' + transferId, { headers })
    }

    checkIfExists(caseId:string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/CaseTransfer/CheckIfExistOffer/' + caseId, { headers })
    }

    getPartnerCaseBadges(caseId:string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/Partner/GetUnreadPartnerMessagesById/' + caseId, { headers })
    }

    getPartners(propertyId:string | null){
        let param = !!propertyId ? "?propertyId=" + propertyId : '';
        const headers = new HttpHeaders({ Authorization: this.bearer });
        return this.http.get(api.jubloApi + 'api/Partner/GetPartnersToCompany' + param, { headers })
    }

    getPartnerResponsibles(partnerCompanyId:string){
        const headers = new HttpHeaders({Authorization: this.bearer });
        return this.http.get(api.jubloApi + 'api/Website/CaseTransfer/GetResponsible/' + partnerCompanyId, { headers })
    }

    /**
     * 
     * @param caseId 
     * @returns object {from: partner, to: partner[], waiting: partner[]  }
     * A frunction that combines the result of getCaseFromPartner, getCaseDistributedPartners and getWaitingPartners in one subscription
     */
    getCasePartnerData(caseId:string):Observable<any>{
        return new Observable(obs => {
            let fromPartner, toPartners, waiting, offers;
            this.getCaseFromPartner(caseId).subscribe({
                next:(data) => {
                    fromPartner = !!data ? data : 'none';
                    if(!!fromPartner && !!toPartners && !!waiting && !!offers) {
                        obs.next({
                            from: fromPartner != 'none' ? fromPartner : null, 
                            to:toPartners != 'none' ? toPartners : null, 
                            waiting:waiting != 'none' ? waiting : null,
                            offers:offers != 'none' ? offers : null
                        });
                        obs.complete();
                    }
                },
                error:(err) => console.error('Could not get origin partner'),
                complete:() => {
                    
                }
            });
            this.getCaseDistributedPartners(caseId).subscribe({
                next:(data) => {
                    toPartners = !!data ? data : 'none'
                    if(!!fromPartner && !!toPartners && !!waiting && !!offers) {
                        obs.next({
                            from: fromPartner != 'none' ? fromPartner : null, 
                            to:toPartners != 'none' ? toPartners : null, 
                            waiting:waiting != 'none' ? waiting : null,
                            offers:offers != 'none' ? offers : null
                        });
                        obs.complete();
                    }
                }
            });
            this.getWaitingPartners(caseId).subscribe({
                next:(data:any[])=> {
                    // Filtering the response, so that accepted/rejected partner requests aren't shown
                    waiting = !!data ? data.filter(x => !x.acceptanceDate && !x.rejectedDate) : 'none';
                    if(!!fromPartner && !!toPartners && !!waiting && !!offers) {
                        obs.next({
                            from: fromPartner != 'none' ? fromPartner : null, 
                            to:toPartners != 'none' ? toPartners : null, 
                            waiting:waiting != 'none' ? waiting : null,
                            offers:offers != 'none' ? offers : null
                        });
                        obs.complete();
                    }
                },
                error:(err)=>{ }
            });
            this.checkIfExists(caseId).subscribe({
                next:(data)=> {
                    offers = !!data ? data : 'none'
                    if(!!fromPartner && !!toPartners && !!waiting && !!offers) {
                        obs.next({
                            from: fromPartner != 'none' ? fromPartner : null, 
                            to:toPartners != 'none' ? toPartners : null, 
                            waiting:waiting != 'none' ? waiting : null,
                            offers:offers != 'none' ? offers : null
                        });
                        obs.complete();
                    }
                }
            })
        })
    }

    getPropertyOwner(propertyId:string){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.get(api.jubloApi + 'api/PropertyLease/GetPropertyCustomer/' + propertyId, { headers })
    }

    getPropertyById(propertyId:string){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.get(api.jubloApi + 'api/PropertyLease/GetPropertyById/' + propertyId, { headers })
    }

    postCaseTransfer(caseTransfer){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.post(api.jubloApi + 'api/Website/CaseTransfer', caseTransfer, { headers })
    }

    editCase(caseId:string, data:{ title:string, description:string,requisitionNumber:string, vorRef:string, departmentId: string, internalNote:string, stade:number }){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.put(api.jubloApi + 'api/Website/Case/EditCase/' + caseId, data, { headers })
    }

    getCaseTags():Observable<Tag[]>{
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.get<Tag[]>(api.jubloApi + 'api/Website/Case/GetCaseTags', { headers })
    }

    addCaseTagToCase(caseId:string, tagId:string){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.patch(api.jubloApi + 'api/Website/Case/AddCaseTagToCase/'+ caseId + '/' + tagId, {} ,{headers})
    }

    removeCaseTagFromCase(caseId:string, tagId:string){
        const headers = new HttpHeaders({Authorization: this.bearer});
        return this.http.patch(api.jubloApi + 'api/Website/Case/RemoveCaseTagFromCase/' + caseId + '/' + tagId, {} ,{headers})
    }

    caseCommunication(caseId: string): Observable<CaseSettings[]> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<Array<CaseSettings>>(api.jubloApi + 'api/Website/Case/GetCaseSettings/' + caseId, { headers });
    }
}

export class CaseStylers {
    static badgeColor(caseStatusId:string) {
        switch (caseStatusId) {
          case '8850aee1-48a3-48a6-aa98-2e1597b7b1d7': return 'badge-success'; // Open
          case '6991f0ea-bdb5-4e30-868f-46c43d712e9b': return 'badge-primary'; // NeedPlanning
          case 'f833a8c3-2944-4a3d-a9b3-8faa01156485':
          case '99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0': return 'badge-warning'; // Canceled
          case '7bccdf15-ad49-4cc9-b358-68e08287f32f': return 'badge-secondary'; // Posted
          case 'bee21fe3-503e-4a8b-8ac4-030929c87741':
          case 'dc604f52-769c-4568-88f5-b77ff41ad95e':
          case 'e958c326-863b-4545-bf13-bb6df821f2fd':
          case 'b56c96f0-0e8c-4a9f-8faf-70eea6f6b0b7': return 'badge-info'; // Offer
          case '5962d8ea-8fa0-4346-836d-a069901a95a2': return 'badge-dark'; // AwaitingAnswer
          case 'a1a453b8-6ae7-453d-bfdb-867ace78654e':
          case '71c47a4a-f277-42c5-8d88-b17db5a4f78f': return 'badge-success'; // Custom/Other
          case '8bfc347c-40c4-42ca-93fc-f4d651c0a109':
          case 'a693c47f-9685-4bb6-bf6e-bcab86cb88de': return 'badge-light'; // Closed
          case 'e65f9d9e-34b2-4423-8ad4-7228db8814b4': return 'badge-danger';
          default: return 'badge-success';
        }
      }
}

export class CaseSettings {
    settingId!: string;
    settingName!: string;
    value!: string;
}